/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How match results are determined
 * @export
 */
export const MatchScoringMode = {
    MANUAL: 'MANUAL',
    EVENT_PIPELINE: 'EVENT_PIPELINE',
    HYBRID: 'HYBRID'
} as const;
export type MatchScoringMode = typeof MatchScoringMode[keyof typeof MatchScoringMode];


export function instanceOfMatchScoringMode(value: any): boolean {
    for (const key in MatchScoringMode) {
        if (Object.prototype.hasOwnProperty.call(MatchScoringMode, key)) {
            if (MatchScoringMode[key as keyof typeof MatchScoringMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MatchScoringModeFromJSON(json: any): MatchScoringMode {
    return MatchScoringModeFromJSONTyped(json, false);
}

export function MatchScoringModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchScoringMode {
    return json as MatchScoringMode;
}

export function MatchScoringModeToJSON(value?: MatchScoringMode | null): any {
    return value as any;
}

export function MatchScoringModeToJSONTyped(value: any, ignoreDiscriminator: boolean): MatchScoringMode {
    return value as MatchScoringMode;
}

